<template>
  <div class="board-page min-w-0">
    <Head :title="__('Chart board')" />
    <Heading v-if="!fullscreen" class="mb-4 md:mb-6">{{ __('Chart board') }}</Heading>
    <BoardApp
      :exchange="exchange"
      :refresh-ms="refreshMs"
      :api-base="apiBase"
      @fullscreen="fullscreen = $event"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import BoardApp from '../components/BoardApp.vue'

defineProps({
  exchange: {
    type: String,
    default: 'Binance',
  },
  refreshMs: {
    type: Number,
    default: 60000,
  },
  apiBase: {
    type: String,
    required: true,
  },
})

const fullscreen = ref(false)
</script>
